module.exports = __webpack_public_path__ + "static/media/icon_pallete.4a07d74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_pallete.png
// module id = 712
// module chunks = 0